import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
// import makeActions from './actions';

import Pagination from '../Pagination/index';

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
    modules: {
        Pagination
    }
};

// const makeStore = (ServiceContainer) => {
//     const actions = makeActions(ServiceContainer);

//     return {
//         namespaced: true,
//         state,
//         getters,
//         mutations,
//         actions,
//         modules: {
//             Pagination
//         }
//     };
// };

// export default makeStore;
